import { connect, ConnectedProps } from 'react-redux'

import ContentHeaderLabel from 'components/accordion/ContentHeaderLabel'
import { setAccordionUrlNode, setSignUpModalIsOpen, setUserRolesModalIsOpen } from 'redux/actions'
import { RootState, AppDispatch } from 'redux/store'

const mapStateToProps = (state: RootState): { isLogged: RootState['user']['isLogged'], controller: RootState['layout']['controller'], flavour: RootState['layout']['flavour'] } => ({
  isLogged: state.user.isLogged,
  controller: state.layout.controller,
  flavour: state.layout.flavour
})

const mapDispatchToProps = (dispatch: AppDispatch): { setAccordionUrlNode: (urlNode: string) => ReturnType<AppDispatch>, setSignUpModalIsOpen: (isOpen: boolean) => ReturnType<AppDispatch>, setUserRolesModalIsOpen: (isOpen: boolean) => ReturnType<AppDispatch> } => ({
  setAccordionUrlNode: (urlNode: string) => dispatch(setAccordionUrlNode(urlNode)),
  setSignUpModalIsOpen: (isOpen: boolean) => dispatch(setSignUpModalIsOpen(isOpen)),
  setUserRolesModalIsOpen: (isOpen: boolean) => dispatch(setUserRolesModalIsOpen(isOpen))
})

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type ContentHeaderLabelContainerProps = ConnectedProps<typeof connector>

export default connector(ContentHeaderLabel)
